"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const FightUpSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.875 16.875H13.125" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.32031 10.9687L4.26562 13.7265C4.65835 14.0947 5.15941 14.3262 5.69429 14.3867C6.22918 14.4473 6.76931 14.3335 7.23437 14.0625L19.0625 7.18746L17.6094 5.40621C17.2314 4.94454 16.7007 4.6333 16.1133 4.5287C15.5258 4.42411 14.9204 4.53307 14.4062 4.8359L10.9375 6.87496L6.25 5.31246L4.96093 5.86715C4.86449 5.90848 4.78001 5.97342 4.71527 6.05599C4.65054 6.13856 4.60763 6.2361 4.5905 6.33962C4.57338 6.44313 4.58259 6.5493 4.61729 6.64832C4.65199 6.74733 4.71106 6.83602 4.78906 6.90621L7.1875 9.06246L5 10.3125L2.8125 9.37496L1.5 9.93746C1.40451 9.97848 1.32075 10.0427 1.25632 10.1242C1.19188 10.2057 1.14879 10.3021 1.13095 10.4044C1.11311 10.5068 1.12108 10.612 1.15415 10.7106C1.18721 10.8091 1.24432 10.8978 1.32031 10.9687V10.9687Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

)

const FightUpIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FightUpSvg} {...props} />
);

export default FightUpIcon